import { PLUGIN_TYPE_ENUM } from '../PluginType.ts';
import {
  defaultClickPixAttribute,
  getAttribute,
  type ScriptParams,
} from './getScriptParams.tsx';
import { hostNodes, type HostNodeConfig } from './hostNodes.tsx';
import { getParamsByPluginType } from './params/getParamsByPluginType.ts';
import type {
  PluginTypeButtonParams,
  PluginTypeOrderParams,
  PluginTypePluginParams,
} from './params/PluginTypeParams.ts';

type NodeWithParams = {
  node: Element;
  pluginType?: string;
  params:
    | PluginTypeButtonParams
    | PluginTypeOrderParams
    | PluginTypePluginParams;
};
export const getNodes = (
  scriptNode?: string,
  scriptParams?: Partial<ScriptParams>,
): NodeWithParams[] => {
  let nodes: NodeWithParams[] = [];

  const getDomNodes = (
    frameDocument: Document,
    nodeConfig: HostNodeConfig,
  ): NodeListOf<any> => {
    if (nodeConfig.pluginType !== PLUGIN_TYPE_ENUM.BUTTON) {
      return frameDocument.querySelectorAll(`#${nodeConfig.id}`);
    }

    return frameDocument.querySelectorAll(`[data-${defaultClickPixAttribute}]`);
  };

  Object.values(hostNodes).map((nodeConfig) => {
    const domNodes = getDomNodes(document, nodeConfig);

    domNodes.forEach((node) => {
      const params = getParamsByPluginType({
        node,
        pluginType: nodeConfig.pluginType as PLUGIN_TYPE_ENUM,
        projectType: nodeConfig.projectType,
        scriptParams,
      });

      const item = {
        node,
        pluginType: nodeConfig.pluginType,
        params,
      };

      nodes = [...nodes, item];
    });

    // Uncaught SecurityError: Failed to read a named property 'document' from 'Window': Blocked a frame with origin "https://woovi.com" from accessing a cross-origin frame
    try {
      // search inside iframes
      const iframes = document.querySelectorAll('iframe');

      iframes.forEach((iframe) => {
        try {
          const iframeDoc =
            iframe.contentDocument || iframe.contentWindow?.document;

          if (!iframeDoc) {
            return;
          }

          const domNodes = getDomNodes(iframeDoc, nodeConfig);

          domNodes.forEach((node) => {
            const params = getParamsByPluginType({
              node,
              pluginType: nodeConfig.pluginType as PLUGIN_TYPE_ENUM,
              projectType: nodeConfig.projectType,
              scriptParams,
            });

            const item = {
              node,
              pluginType: nodeConfig.pluginType,
              params,
            };

            nodes = [...nodes, item];
          });
        } catch (error) {
          // eslint-disable-next-line
          console.error(error);
        }
      });
    } catch (error) {
      // eslint-disable-next-line
      console.error(error);
    }
  });

  if (scriptNode) {
    const defaultNodes = Object.values(hostNodes).map(
      (nodeConfig) => nodeConfig.id,
    );

    // do not include this node twice
    if (!defaultNodes.includes(scriptNode)) {
      const domNodes = document.querySelectorAll(`#${scriptNode}`);

      domNodes.forEach((node) => {
        const item = {
          node,
          params: {
            appID: getAttribute(node, 'data-appid'),
            correlationID: getAttribute(node, 'data-correlationID'),
            paymentLinkID: getAttribute(node, 'data-paymentLinkID'),
          },
        };

        nodes = [...nodes, item];
      });
    }
  }

  return nodes;
};
